/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import Logo from "./../assets/logo/ServiceActivator-DarkBackground.png";
import styles from "./Loading.module.css";
import { ChasingDots } from "styled-spinkit";
import { Auth } from "aws-amplify";

class Loading extends Component {
  componentDidMount() {
    // check if user signed in or not
    setTimeout(() => {
      Auth.currentSession()
        .then((data) => {
          // if signed in show live mode
          this.props.history.replace("live");
        })
        .catch((err) => {
          // if not signed in redirect to login web app 
          window.open(process.env.REACT_APP_AUTH_URL, "_self");
        });
    }, 2000);
  }

  render() {
    return (
      <div className={styles.Container}>
        <div className={styles.InnerCont}>
          <img className={styles.Logo} src={Logo} alt="service activator" />
          <ChasingDots color="#F28E1A" size={45} />
        </div>
      </div>
    );
  }
}

export default Loading;
